import { AuthStore } from 'frontendcommon-3'
import axios from 'axios'

let LOCAL_SHELL_CONFIG_DATA

function mergeArrayData (arrayA, arrayB, key = 'id') {
  arrayA = arrayA.slice()
  arrayB.forEach((itemB) => {
    const index = arrayA.findIndex((itemA) => itemB[key] === itemA[key])
    if (index === -1) arrayA.push(itemB)
    else arrayA[index] = { ...arrayA[index], ...itemB }
  })
  return arrayA
}

export default class AbstractAuth {
  shellConfigLocalUrl = process.env.VUE_APP_SHELL_CONFIG_LOCAL_URL

  async mergeLocalConfig (remoteConfig) {
    if (!this.shellConfigLocalUrl) return remoteConfig
    try {
      LOCAL_SHELL_CONFIG_DATA = LOCAL_SHELL_CONFIG_DATA || (await axios.create().get(this.shellConfigLocalUrl)).data
      remoteConfig.micros = mergeArrayData(remoteConfig.micros, LOCAL_SHELL_CONFIG_DATA.micros)
      remoteConfig.sidebar = mergeArrayData(remoteConfig.sidebar, LOCAL_SHELL_CONFIG_DATA.sidebar)
      return remoteConfig
    } catch (error) {
      console.error(error)
      return remoteConfig
    }
  }

  resolveActiveItem (shellConfig) {
    const actionPathMaps = new Map()
    shellConfig.micros.forEach((micro) => {
      actionPathMaps.set(micro.activation_path, micro.active)
    })
    // create A path object
    const createPath = (url) => { return { url, isActivePath: isActivePath(url) } }

    // Check if path is active. External or not-found path are active by default
    const isActivePath = (url) => {
      const iterator1 = actionPathMaps.entries()
      let isActivePath = !url || url.startsWith('http')
      for (const path of iterator1) {
        if (url.startsWith('/' + path[0])) {
          isActivePath = path[1]
        }
      }
      return isActivePath
    }

    // selct path first active path or first non-active path
    const selectPath = (urlList) => {
      const urlFiltered = urlList.filter((item) => item.isActivePath)
      return (urlFiltered.length)
        ? urlFiltered[0]
        : urlList[0]
    }
    const newSidebar = shellConfig.sidebar.map((item) => {
      let path
      if (item.url instanceof Array) {
        const urlList = item.url.map((path) => { return createPath(path) })
        path = selectPath(urlList)
      } else if (typeof item.url === 'string') {
        path = createPath(item.url)
      }
      return {
        ...item,
        ...path
      }
    })
    return { ...shellConfig, sidebar: newSidebar }
  }

  getAuthHeader (token) {
    return 'Bearer ' + token
  }

  async redirectLogout () {}

  manageTokenError () {
    this.redirectLogout()
    throw new Error('Unauthorized')
  }

  async updateTokenData () {}

  onTokenUnauthorized () {}

  onForbiddenRequest () {}

  refreshToken () {}

  onUpdateAuthDataEnded () {}
  reloadPage () {
    window.location.reload()
  }

  loadNextTo () {
    const nextTo = AuthStore.loadLastAccess()
    const diffMinutes = ((Date.now() - parseInt(nextTo.time)) / 60000)
    if (diffMinutes < 10) {
      return nextTo
    }
    return false
  }

  saveNextTo () {
    const nextTo = {
      path: window.location.pathname + window.location.search
    }
    if (nextTo.path === '/') return
    AuthStore.saveLastAccess(nextTo)
  }

  redirectLogin () { }
}
